import React, { Component } from 'react';
import { connect } from "react-redux";
import SlideToggle from 'react-slide-toggle';
import { getFAQItems } from '../../actions/home'
import { Helmet } from "react-helmet";

class Faq extends Component {

	constructor() {
		super();
		this.state = {
			page: "",
			loading: true
		}
	}
	componentDidMount() {

		// this.props.getFAQItems(this.props.connection_id);
		setTimeout(() => {
			this.setState({
				page: this.props.match.params.id,
				loading: false
			})
		}, 500);
		
	}


	componentWillReceiveProps(nextProps) {
		const { connection_id, store_id } = this.props;
		if (nextProps.match.params.id !== this.props.match.params.id) {
			this.setState({
				page: nextProps.match.params.id,
				loading: true
			})
			setTimeout(() => {
				this.setState({
					loading: false
				})
			}, 500);
		}
	}

	render() {
		

		if (this.props.loading || this.state.loading) {
			return <div className="loading-cls"></div>
		}

		if (this.state.page = "") {
			return <div className="">404</div>
		}

		// 
		return (

			<div>
				<Helmet>
				<title>{this.props.customer_name} | FAQ'S </title>
					<meta name="description" content="" />
				</Helmet>
				<section className="faq-section section-b-space" style={{paddingTop:30}}>
					<div className="container">
						<div className="row ">
							<div className="col-sm-12 ">
							
							<div className="breadcrumb-section" style={{
                        background: 'var(--theme-color)',
                        color: 'white'
                    }}>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="page-title" style={{ display: 'block', textAlignLast: 'center' }}>
                                        <div>Home</div>
                                        <h2 style={{ color: 'white' }}>{`${this.props.match.params.id}`}</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
					<br/>
                                     {/* Mobile Titlw Section */}
                                    {/* <div className="mini-title-divider"></div>
                                     
                                     <div className="mobile-title">
                                        <span>{`${this.props.match.params.id}`}</span>
                                    </div>
                                    <div className="mobile-divider"></div> */}
								<div className="accordion theme-accordion">
									{
										this.props.faqContent[this.props.match.params.id].map((item, index) => {
											return (
												<div key={index}>
													  <div className='row'>
									 				
                            <div className='col-md-6'>
							{item.SSD_ECOM_PAGE_NAME === 'Technologies'?
                                <img style={{ padding: '50px 0 0 0', width: '100%' }} src='https://giantindia.com/wp-content/uploads/2019/09/advanced-composite.jpg' />
                           :'' } </div>
                            <div className={item.SSD_ECOM_PAGE_NAME === 'Technologies'? 'col-md-6' : 'col-md-12' }>
                                <div className='row'>
							{	item.SSD_ECOM_PAGE_NAME === 'Technologies'?
                                    <div className='col-sm-6'>
                                         <img style={{ padding: '50px 0 30px 0' }} src='https://giantindia.com/wp-content/uploads/2019/09/advancedcompositebw_1507879431-200x116.jpg' /> 
                                    </div> : ''}
                                    <div className='col-sm-6'></div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm'>
                                        <h2 style={{lineHeight:'inherit'}}>{item.SSD_ROWID_TITLE}
                                        </h2>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm'>

									{item.SSD_ROWID_DESCRIPTION}
                                    </div>
                                </div>

                            </div>

                        </div>
													
													{/* <SlideToggle
														collapsed={true}
													>
														{({ toggle, setCollapsibleElement }) => (
															<div className="collection-collapse-block" key={index}>
																<div className="collapse-block-title" id="headingSix" onClick={toggle}>
																	<h5 className="mb-0 pr-2">
																		{item.SSD_ROWID_TITLE}
																	</h5>
																</div>
																<div className="collection-collapse-block-content" ref={setCollapsibleElement}>
																	<div className="card-body" style={{'whiteSpace' : 'pre-wrap'}}>
																		{item.SSD_ROWID_DESCRIPTION}
																	</div>
																</div>
															</div>
														)}
													</SlideToggle> */}
										<br/>
												</div>
												
											)

										})
									} 
								</div>
							</div>
						</div>
					</div>
				</section>

			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		logo: state.tenant.tenantLogoURL,
		isAuth: state.user.isAuth,
		connection_id: state.tenant.connection_id,
		loading: state.landing.faqLoading,
		error: state.landing.error,
		faqContent: state.landing.faqContent,
		customer_name: state.tenant.tenant_details.STE_ECOM_BRAND_NAME || "",
	}
}

export default connect(mapStateToProps, { getFAQItems })(Faq)